module.exports = __webpack_public_path__ + "lp/media/AudioSampleTrainers.058ae13f.mp3";